export const mainNavHeight = 65;
export const secondaryNavigation = 71;
export const secondaryNavigationLarge = 120;
export const footerHeight = 82;
export const navHeight = mainNavHeight + secondaryNavigation;
export const additionalHeight = 70;

export const heightThreeStepsActivity = `calc(100vh - ${navHeight}px - ${footerHeight}px - ${additionalHeight}px)`;
export const heightUploadResources = `calc(100vh - ${navHeight}px - ${footerHeight}px - 45px - ${secondaryNavigation}px)`;
